module.exports = __webpack_public_path__ + "assets/devices/ContactVanish-5bc254bf72a12176e5cab871b9832a40.svg";